import { Box, Button, Stack, Typography } from '@mui/material';
import FeedbacksChangeIcon from '@/assets/images/svg/feedbacks-change.svg';
import { BaseDialog } from '@/components/shared/base-dialog';

type ConfirmDialogProps = {
  onClose: () => void;
  onSubmit: () => void;
};

const Actions = ({ onClose, onSubmit }: ConfirmDialogProps) => (
  <Stack spacing={2} direction="row" justifyContent="flex-end">
    <Button onClick={onClose}>Não</Button>
    <Button variant="contained" onClick={onSubmit}>
      Sim
    </Button>
  </Stack>
);

export const ConfirmDialog = ({ onClose, onSubmit }: ConfirmDialogProps) => {
  return (
    <BaseDialog
      actionsComponent={<Actions onClose={onClose} onSubmit={onSubmit} />}
      fullWidth
      maxWidth="xs"
      title="Alterar o feedback atualizará suas habilidades"
      icon={
        <Box
          component="img"
          src={FeedbacksChangeIcon}
          sx={{ height: 60, width: 60 }}
        />
      }
      onClose={onClose}
      open
    >
      <Typography>
        Ao prosseguir, as habilidades serão recalculadas e você perderá as
        habilidades selecionadas. Tem certeza que deseja continuar?
      </Typography>
    </BaseDialog>
  );
};
